import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

const SessionForm = ({ onSubmit, submitting, initialValues, isEdit }) => {
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (initialValues) {
      setName(initialValues.name || "");
      setStartDate(
        initialValues.start_date ? new Date(initialValues.start_date) : null
      );
      setEndDate(
        initialValues.end_date ? new Date(initialValues.end_date) : null
      );
      setIsActive(!!initialValues.is_active);
    }
  }, [initialValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !startDate || !endDate) return;
    onSubmit({
      name,
      start_date: startDate,
      end_date: endDate,
      is_active: isActive,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-fluid">
      <div className="p-field flex justify-content-between align-items-center gap-3" style={{ marginBottom: "1rem" }}>
        <div className="w-full ">
          <label htmlFor="name">Name</label>
          <InputText
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full border-1 border-gray-400"
          />
        </div>
        
      </div>
      <div className="p-field flex gap-4" style={{ marginBottom: "1rem" }}>
      <div className="p-field w-full md:w-6" style={{  }}>
          <label htmlFor="startDate">Start Date</label>
          <Calendar
            id="startDate"
            value={startDate}
            onChange={(e) => setStartDate(e.value)}
            showIcon
            dateFormat="yy-mm-dd"
            required
            className="w-full border-1 border-gray-400 border-round-md"
          />
        </div>
        <div className="p-field w-full md:w-6">
          <label htmlFor="endDate">End Date</label>
          <Calendar
            id="endDate"
            value={endDate}
            onChange={(e) => setEndDate(e.value)}
            showIcon
            dateFormat="yy-mm-dd"
            required
            className="w-full border-1 border-gray-400 border-round-md"
          />
        </div>
      </div>
        <div className="p-field-checkbox" style={{ marginBlock: "1rem" }}>
          <Checkbox
            inputId="active"
            checked={isActive}
            onChange={(e) => setIsActive(e.checked)}
          />
          <label htmlFor="active" style={{ marginLeft: "0.5rem" }}>
            Set as Active
          </label>
        </div>
      <Button
        type="submit"
        label={
          submitting
            ? isEdit
              ? "Updating..."
              : "Saving..."
            : isEdit
            ? "Update"
            : "Save"
        }
        disabled={submitting}
      />
    </form>
  );
};

export default SessionForm;
